import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import Seo from "@/components/Seo";

// Visual 404 (SPA). Marked noindex; a true HTTP 404 requires server-side rendering/hosting rules (see report).
export default function NotFound() {
  return (
    <main className="bg-[#F5EFE7] text-[#451C25] min-h-screen pt-[136px] lg:pt-[126px]">
      <Seo title="Page not found | Destino Europe" description="This page is not available." path={typeof window !== "undefined" ? window.location.pathname : "/404"} noindex />
      <Header />
      <section data-testid="not-found" className="px-6 md:px-10 lg:px-14 py-24 max-w-3xl mx-auto">
        <p className="text-[#897756] text-[11px] tracking-[0.3em] uppercase font-semibold" style={{ fontFamily: "Kanit, Arial, sans-serif" }}>404</p>
        <h1 className="mt-4 text-4xl sm:text-5xl" style={{ fontFamily: "Kanit, Arial, sans-serif", fontWeight: 600 }}>This page isn't here.</h1>
        <p className="mt-6 text-[#6B4954] text-lg" style={{ fontFamily: "'Noto Serif', Georgia, serif" }}>Try the <Link to="/" className="underline underline-offset-4">home page</Link>, <Link to="/spain/moving-to-spain/" className="underline underline-offset-4">moving to Spain</Link> or our <Link to="/resources" className="underline underline-offset-4">resources</Link>.</p>
      </section>
      <Footer />
    </main>
  );
}
